import React from 'react';
import {Dialog, IconButton} from "@mui/material";
import error from "assets/icon/error.svg"
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';


const DialogError = ({open, onClose, message}) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="xs"
            onClose={onClose}
        >
            <div className="relative">
                <IconButton className="!absolute right-2 top-2" size="small" onClick={onClose}><HighlightOffRoundedIcon/></IconButton>
                <div className="py-20 flex flex-col items-center justify-center">
                    <img src={error} alt=""/>
                    <div className="text-3xl text-red-500 mb-4 font-semibold">Lỗi!</div>
                    <div className="px-4">{message}</div>
                </div>

            </div>
        </Dialog>
    )
}

export default DialogError